import React from 'react'
import { Add } from '@mui/icons-material'
import Checkbox from '../Checkbox'
import { ListItem, ListItemIcon, ListItemText } from '../List'
import { ComboBoxOption, ComboBoxGroupedOption, OPTION_TYPE_CREATE } from './helper/utils'
import ComboBoxContext from './ComboBoxContext'

type Props<T = ComboBoxOption> = {
  isGroup?: boolean
  isNested?: boolean
  item: T | ComboBoxGroupedOption<T>
  index: number
  style?: object
}

const RowOption = <T extends ComboBoxOption>({ isGroup = false, isNested = false, item, index, style }: Props<T>) => {
  const {
    classes,
    filteredOptions,
    getItemProps,
    getOptionDisabled,
    getOptionLabel,
    getOptionValue,
    isOptionSelected,
    multiple,
    selectedItems,
    addSelectedItem,
    removeSelectedItem,
  } = React.useContext(ComboBoxContext)

  if (isGroup) {
    const groupItem = item as ComboBoxGroupedOption<T>
    return (
      <ListItem
        role='option'
        aria-label={`Option group ${groupItem.group}`}
        className={classes.groupLabel}
        style={style && style}
        quiet
      >
        <ListItemText>{groupItem.group}</ListItemText>
      </ListItem>
    )
  }

  const { onClick, ...itemProps } = getItemProps({ item, index })

  const isAddOption = (filteredOptions.filtered[index] as any).__type === OPTION_TYPE_CREATE
  return (
    <ListItem
      className={isNested && classes.groupItem}
      style={style && style}
      disabled={getOptionDisabled(item)}
      quiet
      selected={isOptionSelected(selectedItems, item, getOptionLabel)}
      {...itemProps}
      // 💥 Fix mobile/tablette : déclencher la sélection avant blur
      onPointerDown={(e) => {
        if (!multiple) {
          onClick?.(e)
        } else {
          const isSelected = isOptionSelected(selectedItems, item, getOptionLabel)
          if (isSelected) {
            removeSelectedItem(item)
          } else {
            addSelectedItem(item)
          }
        }
      }}
      onClick={(e) => {
        // onclick n'est pas appelé si on ferme les options de select mutliple donc je le gère à la main dans onpointerdown
        if (!multiple) onClick?.(e)
      }}
    >
      {isAddOption ? (
        <>
          <ListItemIcon>
            <Add />
          </ListItemIcon>
          <ListItemText>Add "{getOptionLabel(item)}"</ListItemText>
        </>
      ) : (
        <>
          {multiple && (
            <ListItemIcon className={classes.checkbox}>
              <Checkbox
                checked={isOptionSelected(selectedItems, item, getOptionLabel)}
                value={getOptionValue(item)}
                onChange={(evt: any) => evt.preventDefault()}
                rootProps={{
                  onClick: (evt: any) => evt.preventDefault(),
                }}
              />
            </ListItemIcon>
          )}
          <ListItemText>{getOptionLabel(item)}</ListItemText>
        </>
      )}
    </ListItem>
  )
}

export default RowOption
